/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const UserAttributes: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <rect x={14} y={10} width={2} height={2} />

      <rect x={14} y={14} width={2} height={2} />

      <rect x={18} y={10} width={4} height={2} />

      <rect x={18} y={14} width={4} height={2} />

      <rect x={14} y={18} width={2} height={2} />

      <rect x={18} y={18} width={4} height={2} />

      <path fillRule="evenodd" clipRule="evenodd" d="M12 20V18.5H2.5V17.25C2.5 16.71 5.06 15.5 7.5 15.5C9.28609 15.5 11.1365 16.1484 12 16.7077V15C10.57 14.33 8.7 14 7.5 14C5.33 14 1 15.08 1 17.25V20H12ZM11 9.5C11 11.43 9.43 13 7.5 13C5.57 13 4 11.43 4 9.5C4 7.57 5.57 6 7.5 6C9.43 6 11 7.57 11 9.5ZM9.5 9.5C9.5 8.4 8.6 7.5 7.5 7.5C6.4 7.5 5.5 8.4 5.5 9.5C5.5 10.6 6.4 11.5 7.5 11.5C8.6 11.5 9.5 10.6 9.5 9.5Z" />

    </StyledIconBase>
  )
})

UserAttributes.displayName = 'UserAttributes'

export const UserAttributesDimensions = {height: 24, width: 24}
